import React from 'react'
import { Autocomplete } from '@core/Components/Autocomplete'
import { useAutoCompleteAddressList } from '@mobi/account/Areas/ContactDetails/Hooks'
import { debounceWithReturn } from '../Account/SignUp/Old/IdentityConfirmation/AddressQueries'

export const AddressAutosuggest = Autocomplete as new () => Autocomplete<string>

const getSuggestionValue = (suggestion: string) => suggestion

interface AddressAutocompleteProps {
  id: string
  inputId?: string
  value?: string | null
  autoFocus?: boolean
  errorMessage: string | boolean
  backgroundColor?: string
  fontFamily?: string
  disabled?: boolean
  onSelection(suggestion: string | null): void
}

export function AddressAutocomplete({
  id,
  inputId,
  value = null,
  errorMessage,
  onSelection,
  autoFocus,
  backgroundColor,
  fontFamily,
  disabled,
}: AddressAutocompleteProps): JSX.Element {
  const search = useAutoCompleteAddressList()

  const fetchSuggestedAddresses = debounceWithReturn((inputValue: string) => {
    if (!inputValue || inputValue.length < 3) {
      return []
    }

    return search(inputValue)
      .then(resp => resp.map(({ value }) => value))
      .catch(() => [])
  }, 750) as (inputValue: string) => Promise<string[]>

  return (
    <AddressAutosuggest
      id={id}
      selection={value}
      inputProps={{ id: inputId }}
      errorMessage={errorMessage}
      autoFocus={autoFocus}
      backgroundColor={backgroundColor}
      fontFamily={fontFamily}
      disabled={disabled}
      onSelection={onSelection}
      getSuggestionValue={getSuggestionValue}
      getSuggestionsForInputValue={fetchSuggestedAddresses}
    />
  )
}
